import React from "react";
import LocationsMarquee from "../LocationsMarquee";

const AirFreightServices = () => {
  return (
    <div>
 {/* Hero Section */}
 <div
          className="relative w-full h-screen bg-cover bg-center flex items-center justify-center text-white"
          style={{ backgroundImage: "url('/images/aircargo.jpg')" }}
        >
          <div className="absolute inset-0 bg-black bg-opacity-50"></div>
          <div className="relative text-center px-6">
            <h1 className="text-5xl md:text-8xl font-semibold"> Air Freight Solutions</h1>
            <p className="mt-4 text-lg md:text-xl text-gray-200 max-w-2xl mx-auto">
              Reliable & fast air freight solutions for businesses across World, ensuring seamless logistics for time-sensitive shipments.
            </p>
            <a
              href="/contactus"
              className="mt-6 inline-block bg-gray-800 border hover:bg-gray-600 text-white px-6 py-3 text-lg font-semibold  transition"
            >
              Get a Free Quote
            </a>
          </div>
        </div>


        <LocationsMarquee/>

    <h1 className=" text-4xl md:text-5xl lg:text-6xl text-black text-center mt-12 font-thin lg:p-4">Reliable Air Freight Solutions Worldwide</h1>



     {/* <TransportCards/> */}
     <div className="flex flex-col lg:flex-row items-center p-4 md:p-8 justify-center space-y-6 md:space-y-0 md:gap-10 xl:gap-40 xl:mt-32">
        <div className="lg:w-1/2 2xl:w-1/3  md:hidden flex justify-center">
            <img 
              src="images/qatar.jpg" 
              alt="Freight Platform" 
              className="w-full h-[500px] max-w-md lg:max-w-full rounded-3xl transition-transform duration-300 ease-in-out transform hover:scale-105"
            />
          </div>
          <div className=" md:px-12  lg:px-0 lg:w-1/2 2xl:w-1/3 text-center md:text-left space-y-4 md:text-lg">
          <p className="text-3xl md:text-4xl text-center xl:text-4xl font-thin text-gray-800 mb-8">
          Digital Air Freight Solutions</p>
<ul className="mt-6 text-lg text-gray-700 text-left space-y-4 font-thin">
                <li  className="flex items-start gap-2">
                  <span className=" text-xl  md:text-2xl">✔</span>
                  <span className="w-full  text-xl  md:text-2xl">1UKLogistics holds Airway Bill stock for more than 100 airlines. </span>
                </li>
                <li  className="flex items-start gap-2">
                  <span className=" text-xl  md:text-2xl">✔</span>
                  <span className="w-full  text-xl  md:text-2xl">Seamless airport-to-airport cargo transfers. </span>
                </li>
                <li  className="flex items-start gap-2">
                  <span className=" text-xl  md:text-2xl">✔</span>
                  <span className="w-full  text-xl  md:text-2xl">Reliable door-to-door delivery solutions. </span>
                </li>
                <li  className="flex items-start gap-2">
                  <span className=" text-xl  md:text-2xl">✔</span>
                  <span className="w-full  text-xl  md:text-2xl">Efficient cargo consolidation for cost-effective shipping.</span>
                </li>
                <li  className="flex items-start gap-2">
                  <span className=" text-xl  md:text-2xl">✔</span>
                  <span className="w-full  text-xl  md:text-2xl">Efficient cargo consolidation for cost-effective shipping.</span>
                </li>
                <li  className="flex items-start gap-2">
                  <span className=" text-xl  md:text-2xl">✔</span>
                  <span className="w-full  text-xl  md:text-2xl">Precise, time-defined logistics solutions.</span>
                </li>
                <li  className="flex items-start gap-2">
                  <span className=" text-xl  md:text-2xl">✔</span>
                  <span className="w-full  text-xl  md:text-2xl">Expert handling for temperature-sensitive, high-value cargo.</span>
                </li>
                <li  className="flex items-start gap-2">
                  <span className=" text-xl  md:text-2xl">✔</span>
                  <span className="w-full  text-xl  md:text-2xl">Upload, view, and access your eDocs with ease.</span>
                </li>
                <li  className="flex items-start gap-2">
                  <span className=" text-xl  md:text-2xl">✔</span>
                  <span className="w-full  text-xl  md:text-2xl">Real-time, web-based global shipment tracking..</span>
                </li>
                <li  className="flex items-start gap-2">
                  <span className=" text-xl  md:text-2xl">✔</span>
                  <span className="w-full  text-xl  md:text-2xl">Manage, monitor, and plan with SKU-level visibility.</span>
                </li>
                <li  className="flex items-start gap-2">
                  <span className=" text-xl  md:text-2xl">✔</span>
                  <span className="w-full  text-xl  md:text-2xl">  Internal management of customs procedures.</span>
                </li>
                <li  className="flex items-start gap-2">
                  <span className=" text-xl  md:text-2xl">✔</span>
                  <span className="w-full  text-xl  md:text-2xl">Seamless booking through our e-freight tools.</span>
                </li>
            </ul>

          
          </div>
          <div className=" hidden lg:w-1/2 2xl:w-1/3 md:flex justify-center">
            <img 
              src="images/qatar.jpg" 
              alt="Freight Platform" 
              className="w-full h-[800px] max-w-xs md:max-w-full rounded-3xl transition-transform duration-300 ease-in-out transform hover:scale-105"
            />
          </div>
        </div>

     <div className="flex flex-col lg:flex-row items-center p-4  md:p-8  justify-center space-y-6 md:space-y-0 md:gap-10 xl:gap-40 xl:mt-20">
          <div className="lg:w-1/2 2xl:w-1/3 flex justify-center">
            <img 
              src="images/air1.png" 
              alt="Freight Platform" 
              className="w-full h-auto max-w-xs md:max-w-full rounded-3xl transition-transform duration-300 ease-in-out transform hover:scale-105"
            />
          </div>
          <div className="lg:w-1/2 2xl:w-1/3 text-center md:text-left space-y-4 md:text-lg">
          {/* <p className="text-xl lg:text-2xl xl:text-4xl font-bold text-gray-800">
          Explore your complete digital freight solution in one platform.
   </p> */}
   <p className=" text-xl  md:text-2xl  font-thin text-justify max-w-xl md:leading-10 text-gray-600">
   When speed and efficiency matter most, our air freight services ensure your shipments reach their destination on time, every time. We specialize in seamless logistics, offering reliable air cargo solutions to Dubai, India, the USA, and destinations across the globe.
    With a network of trusted airline partners, we provide fast and secure transport for businesses of all sizes.
   </p>
            {/* <div className='flex justify-center pt-4'>
            <Link to='/contactus'>
              <button className="bg-slate-800 text-white px-6 py-2 rounded-xl hover:bg-slate-600 transition-colors duration-300">
                Schedule a Demo
              </button></Link>
            </div> */}
          </div>
        </div>
  
        <div className="flex flex-col lg:flex-row items-center p-4 md:p-8 justify-center space-y-6 md:space-y-0 md:gap-10 xl:gap-40 xl:mt-32">
        <div className="lg:w-1/2 2xl:w-1/3  md:hidden flex justify-center">
            <img 
              src="images/air2.jpg" 
              alt="Freight Platform" 
              className="w-full h-auto max-w-xs lg:max-w-full rounded-3xl transition-transform duration-300 ease-in-out transform hover:scale-105"
            />
          </div>
          <div className="  lg:w-1/2 2xl:w-1/3 text-center md:text-left space-y-4 md:text-lg">
          {/* <p className="text-xl lg:text-2xl xl:text-4xl font-bold text-gray-800">
          Flexible logistics solutions that combine technology
           and expertise to help you fulfill your promises to customers.
   </p> */}
   <p className="text-xl md:text-2xl font-thin text-justify max-w-xl md:leading-10 text-gray-600">
   Our expertise in international air freight ensures hassle-free shipping with streamlined customs clearance and end-to-end tracking.
    Whether you need express delivery for urgent shipments or cost-effective options for bulk cargo, we tailor our services to meet your specific needs.
    From commercial goods to personal consignments, we handle it all with precision and care.
   </p>
          </div>
          <div className=" hidden lg:w-1/2 2xl:w-1/3 md:flex justify-center">
            <img 
              src="images/air2.jpg" 
              alt="Freight Platform" 
              className="w-full h-auto max-w-xs md:max-w-full rounded-3xl transition-transform duration-300 ease-in-out transform hover:scale-105"
            />
          </div>
        </div>
  
  
        <div className="flex flex-col lg:flex-row items-center p-4 md:p-8 justify-center space-y-6 md:space-y-0 lg:gap-10 xl:gap-40 xl:mt-32 ">
          <div className="lg:w-1/2 2xl:w-1/3 flex justify-center">
            <img 
              src="images/air3.jpg" 
              alt="Freight Platform" 
              className="w-full h-auto max-w-xs md:max-w-full rounded-3xl transition-transform duration-300 ease-in-out transform hover:scale-105"
            />
          </div>
          <div className="lg:w-1/2 2xl:w-1/3 text-center md:text-left space-y-4 md:text-lg">
        
   <p className="text-xl md:text-2xl font-thin max-w-xl md:leading-10 text-gray-600">
   No matter where your cargo needs to go, we’ve got you covered. Our global reach, competitive rates, and dedicated customer support make us the preferred choice for air freight logistics. Trust us to deliver your shipments safely, securely, and swiftly, keeping your business moving forward. 
   With strict safety protocols and real-time tracking, we ensure your cargo is always in good hands.
   </p>
            
          </div>
        </div>
  
        <section className="relative  bg-cover  bg-no-repeat w-full  py-36 mt-20" style={{ backgroundImage: "url('images/footerlable3.jpg') " }}>
          <div className="absolute inset-0 bg-black bg-opacity-50"></div>
          <div className="relative z-10 container mx-auto text-center text-white px-6">
          <h2 className="text-3xl md:text-[45px] mb-6 font-thin">For more information about our Air Freight Solutions, please contact us.</h2>
            <div className=" flex justify-center">
            </div>
          
            <a
              href="/contactus"
              className="inline-block bg-gray-200 text-black  px-8 py-2 md:py-3 uppercase shadow-lg hover:bg-slate-800 hover:text-white transition duration-300"
            >
              Contact Us
            </a>
          </div>
        </section>
       
    </div>


  );
};
  

export default AirFreightServices;
